import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrVerificationDocumentType.ts
var t = () => e("verificationDocumentType");
//#endregion
export { t as useTrVerificationDocumentType };
